export { AboutSection } from './About';
export { FAQsSection } from './FAQs';
export { FeaturedDocuments } from './FeaturedDocuments';
export { HeroSection } from './Hero';
export { HookSection } from './Hook';
export { InfoSection } from './Info';
export { ModulesSection } from './Modules';
export { SignupCtaSection } from './SignupCta';
export { TestimonialsSection } from './Testimonials';
export { TutorfairReviewCarousel } from './TutorfairReviewCarousel';
export { TopicSection } from './Topics';
export { MotivationSection } from './Motiviation';
